import instance from "./instance";
import { ENV } from "@/constants/env";
import { ResponseDataDto } from "@/dto/ResponseDto";
import {
  MaterialRequestCategoryResponseDto,
  CreateMaterialRequestCategoryDto,
  UpdateMaterialRequestCategoryDto,
  BulkCreateMaterialRequestCategoryDto,
} from "@/dto/MaterialRequestCategoryDto";

// 자료 요청 카테고리 관리 API 경로
const PREFIX_PATH = "admin/material-request";

/**
 * 자료요청 카테고리 목록 조회
 * @param comId 회사 ID
 * @returns 자료요청 카테고리 목록
 */
export const findAllCategories = async (
  comId: number | string
): Promise<ResponseDataDto<MaterialRequestCategoryResponseDto[]>> => {
  // 캐시 방지를 위한 타임스탬프 추가
  const timestamp = new Date().getTime();
  const query = `?comId=${comId}&_t=${timestamp}`;

  return await instance.get(`${ENV.PRE_FIX}/${PREFIX_PATH}/category${query}`);
};

/**
 * 자료요청 카테고리 상세 조회
 * @param categoryId 카테고리 ID
 * @returns 카테고리 상세 정보
 */
export const findOneCategory = async (
  categoryId: number | string
): Promise<ResponseDataDto<MaterialRequestCategoryResponseDto>> => {
  return await instance.get(
    `${ENV.PRE_FIX}/${PREFIX_PATH}/category/${categoryId}`
  );
};

/**
 * 자료요청 카테고리 생성
 * @param request 카테고리 생성 요청 DTO
 * @returns 생성된 카테고리 정보
 */
export const createCategory = async (
  request: CreateMaterialRequestCategoryDto
): Promise<ResponseDataDto<MaterialRequestCategoryResponseDto>> => {
  return await instance.post(`${ENV.PRE_FIX}/${PREFIX_PATH}/category`, request);
};

/**
 * 자료요청 카테고리 수정
 * @param categoryId 카테고리 ID
 * @param request 카테고리 수정 요청 DTO
 * @returns 수정된 카테고리 정보
 */
export const updateCategory = async (
  categoryId: number | string,
  request: UpdateMaterialRequestCategoryDto
): Promise<ResponseDataDto<MaterialRequestCategoryResponseDto>> => {
  return await instance.patch(
    `${ENV.PRE_FIX}/${PREFIX_PATH}/category/${categoryId}`,
    request
  );
};

/**
 * 자료요청 카테고리 삭제
 * @param categoryId 카테고리 ID
 * @returns 응답 정보
 */
export const removeCategory = async (
  categoryId: number | string
): Promise<ResponseDataDto<null>> => {
  return await instance.delete(
    `${ENV.PRE_FIX}/${PREFIX_PATH}/category/${categoryId}`
  );
};

/**
 * 다수 자료요청 카테고리 일괄 생성
 * @param request 일괄 생성 요청 DTO
 * @returns 생성된 카테고리 목록
 */
export const createCategories = async (
  request: BulkCreateMaterialRequestCategoryDto
): Promise<ResponseDataDto<MaterialRequestCategoryResponseDto[]>> => {
  return await instance.post(
    `${ENV.PRE_FIX}/${PREFIX_PATH}/categories`,
    request
  );
};
